<ng-container *ngIf="pageData; else loadingPage">
  <air-hero [content]="pageData.hero" [additionalHeroes]="pageData.additionalHeroes" [showPartnersList]="true"></air-hero>
  <div class="container content content--homepage">
    <div class="content-section">
      <div class="content-panel">
        <div class="content content--primary grid">
          <div class="col-12 col-6--md col-4--sm">
            <air-content-blocks [content]="pageData.primaryContent" [region]="contentBlockRegion.primary"></air-content-blocks>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="pageData.highlightedContent && pageData.highlightedContent.length > 0" class="content-section content--highlighted">
      <air-content-blocks [content]="pageData.highlightedContent" [region]="contentBlockRegion.highlighted"></air-content-blocks>
    </div>
  </div>
</ng-container>

<ng-template #loadingPage>
  <air-skeleton-page></air-skeleton-page>
</ng-template>
